import { render } from "./BigImg.vue?vue&type=template&id=0ff3790a&scoped=true"
import script from "./BigImg.vue?vue&type=script&lang=js"
export * from "./BigImg.vue?vue&type=script&lang=js"

import "./BigImg.vue?vue&type=style&index=0&id=0ff3790a&lang=css&scoped=true"

import exportComponent from "D:\\project_h5\\mydyH5_Code\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ff3790a"]])

export default __exports__